import { createStyles } from '@byecode/ui/theme/createStyles'
import { css } from '@byecode/ui/theme/stitches.config'
import clsx from 'clsx'
import React from 'react'

import { useContextPopoverHeight } from '../../../hooks/usePopoverHeight'
import { Popover } from '../Popover'
import { usePopoverContext } from '../Popover.context'
import { type PopoverDropdownProps } from './PopoverDropdown'

interface AutoResizeDropdownProps extends PopoverDropdownProps {
    initMaxHeight?: number
    offset?: number
}

const useStyles = createStyles(() => ({
    dropdown: css({
        prettyScroll: true
    })
}))

export const AutoResizeDropdown: React.FC<AutoResizeDropdownProps> = props => {
    const { initMaxHeight, className, offset, ...rest } = props
    const { classes } = useStyles({}, { name: 'autoResizeDropdown' })
    const { context } = usePopoverContext()
    const [maxHeight, ref] = useContextPopoverHeight({ context, initMaxHeight: initMaxHeight || 640, offset })
    return <Popover.Dropdown className={clsx(className, classes.dropdown)} ref={ref} {...rest} style={{ maxHeight }} />
}
